// src/Pages/Cadastro/CadImportProducts.tsx
import { useContext, useState } from 'react';
import { Container } from 'react-bootstrap';
import { ThemeContext } from '../../context/theme-context';
import ListaImportProducts from '../../Components/Cadastro/ImportProducts/ListaImportProducts';
import FormImportProducts from '../../Components/Cadastro/ImportProducts/FormImportProducts';

export interface IListImportProducts {
  title: string;
  OnAddNewImport: (e: boolean) => void;
}

export interface IFormImportProducts {
  title: string;
  OnAddNewImport: (e: boolean) => void;
}

export default function CadImportProducts() {
  const { collapsed } = useContext(ThemeContext);
  const [showForm, setShowForm] = useState<boolean>(false);

  const handleNew = (e: boolean) => {
    setShowForm(e);
  };

  return (
    <>
      {!showForm ? (
        <Container
          className={collapsed ? 'contenteLayoutCollapsed' : 'contenteLayout'}
        >
          <ListaImportProducts
            title="Importação de Produtos"
            OnAddNewImport={(e: boolean) => handleNew(e)}
          />
        </Container>
      ) : (
        <Container
          className={collapsed ? 'contenteLayoutCollapsed' : 'contenteLayout'}
        >
          <FormImportProducts
            title="Importar Produtos e Categorias"
            OnAddNewImport={(e: boolean) => handleNew(e)}
          />
        </Container>
      )}
    </>
  );
}